import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactMarkdown from 'components/Markdown/Markdown';
import { DumbField } from './Field';
import { stateOptions, getCountryOptions } from '../Wizard2/selectOptions';
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import SearchIcon from '@tecuity/sos-icons/react/search'
import {DateInput, HOUR_OPTIONS, MINUTE_OPTIONS} from '../Wizard2/fieldComponents/Form'

export class DummyTextField extends Component {
	render() {
		const {
			width,
			height = '',
			disabled,
			className='',
			value,
			placeholder,
			textAlignment = 'left',
			style = {}
		} = this.props
		return (
			<div
				style={{ width: width, height: height, textAlign: textAlignment, ...style }}
				className={(disabled ? 'text disabled ' : 'text ') + className}
			>
				{value
					? <div className="value">
							{value}
						</div>
					: <div className="placeholder">
							{placeholder}
						</div>}
			</div>
		)
	}
}

export class DummySelectField extends Component {
	render() {
    const { width, className='', value, disabled, placeholder } = this.props;
		return (
			<DummyTextField
				width={width}
				placeholder={placeholder}
				className={'select ' + className}
				value={value}
				disabled={disabled}
			/>
		)
	}
}

export class DummyConfirmFields extends Component {
  render(){
    const { value={}, required, label, secondLabel, placeholder, description='', width, disabled } = this.props;
    return(
      <div className="block-wrapper">
        <span className={required ? "label-text required " : "label-text "}>{label}</span>
        {description !== "" ? <ReactMarkdown className="description" source={description} escapeHtml /> : null}
        <DummyTextField value={value.val1} width={width} placeholder={placeholder} disabled={disabled} />
        <span className={required ? "label-text required " : "label-text "}>{secondLabel}</span>
        <DummyTextField value={value.val2} width={width} placeholder={placeholder} disabled={disabled}/>
      </div>
    )
  }
}

export class DummyServerSearch extends Component {
  render(){
    return(
      <div className="block-wrapper dummy-server-search">
        <div className="block-wrapper search sub-section">
          <div className="row">
            <div className="col-sm-5">
              <DumbField type="text" required={false} parentType="addressBlock" label="First Name">
                <DummyTextField value="" width="100%" placeholder="" />
              </DumbField>
            </div>
            <div className="col-sm-3">
              <DumbField type="text" required={false} parentType="addressBlock" label="Middle Name">
                <DummyTextField value="" width="100%" placeholder="" />
              </DumbField>
            </div>
            <div className="col-sm-4">
              <DumbField type="text" required={false} parentType="addressBlock" label="Last Name">
                <DummyTextField value="" width="100%" placeholder="" />
              </DumbField>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 search-col">
              <DumbField type="text" required={false} parentType="addressBlock" label="Business Name">
                <DummyTextField value="" width="100%" placeholder="" />
              </DumbField>
              <button className="btn search-button">Search</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class DummyRadio extends Component {
  render(){
		const { options, disabled, leftAlign } = this.props;
    return(
      <div className={`radio ${leftAlign ? 'left-align' : ''}`}>
        {
          options.map((option, i) => {
            return (
              <div className="radio-option" key={i}>
                <div className={"radio-control" + (disabled ? " disabled" : "")} key={option.value || i}></div>
                <div className="radio-label" key={"label" + i}>{option.label}</div>
              </div>
            )
          })
        }
      </div>
    )
  }
}

export class DummyCheckbox extends Component {
  render(){
    let props = this.props;
    let { description } = this.props;
    return(
			<div className="dummy-checkbox-wrapper">
				{typeof description === "string" && description !== "" ? <span><ReactMarkdown className="description" source={description} escapeHtml /></span> : null}
	      <div className="dummy-checkbox">
	        <div className={"dummy-box " + (props.disabled ? "disabled" : "")}>{props.checked ? <div className="check"></div> : null}</div>
	        <label className="label-text">{props.label}{props.required ? <span className="required">*</span> : null}</label>
	      </div>
			</div>
    )
  }
}

export const DummyDateInput = ({disabled, width, todayButton}) => (
	<div className='flex-row dummy-date-wrapper'>
		<div style={{width: width}} className={"text" + (disabled ? " disabled" : "")}/>
		{
			todayButton &&
			<button className='btn btn-raised' tabIndex={-1}>Today</button>
		}
		<button className='btn btn-raised calendar' tabIndex={-1}>
			<div className='center-wrapper'><CalendarIcon/></div>
		</button>
	</div>
)

export const DummyDateRange = ({disabled, startLabel = '', endLabel = '', required}) => (
	<div className='row'>
		<div className='col-sm-4 col-md-5'>
			<span className={"label-text " + (required ? "required" : "")}>{startLabel}</span>
      <div className={"text date" + (disabled ? " disabled" : "")}></div>
		</div>
		<div className='col-sm-4 col-md-5'>
      <span className={"label-text " + (required ? "required" : "")}>{endLabel}</span>
      <div className={"text date" + (disabled ? " disabled" : "")}></div>
		</div>
	</div>
)

export class DummyFileUpload extends Component {
  render(){
    const { disabled, multiple} = this.props;
    return (
      <div className="file-wrapper">
        <div className="row">
          <div className="col-xl-7 col-lg-8 col-md-9">
            <label className={`styled-file-upload ${disabled ? 'disabled' : ''}`}>
              <span className="icon icon-upload" />
              {
                multiple ?
                  "Select files to upload"
                  :
                  "Select a file to upload"
              }
            </label>
          </div>
        </div>
      </div>
    )
  }
}

export class DummyDependent extends Component {
  render(){
    return (
      <div className="block-wrapper" disabled={this.props.disabled}>
        {this.props.children}
        {/* {this.props.fields.map((field, i) => {
          return (
            <Field
              isNestedField={true}
              ref={"field" + i}
              className="sub-field"
              {...field}
              stepIndex={this.props.stepIndex}
              sectionIndex={this.props.sectionIndex}
              fieldIndex={i}
              selected={this.props.selected}
              isFirst={i === 0}
              isLast={(this.props.fields.length - 1) === i}
              key={i}
            />
          )
        })} */}
      </div>
    )
  }
}
DummyDependent = connect(
  (state, props) => ({
    fields: props.fields.map((fieldId) => (state.designer.wizard.fields[fieldId]))
  })
)(DummyDependent)

export class DummyAddressBlock extends Component{
  render(){
    let stateOption = stateOptions.find(option => option.value === this.props.value.STATE)
    let selectedState = stateOption ? stateOption.label : '';
    let selectedCountry = getCountryOptions().find((option) => {
      return option.value === this.props.value.COUNTRY
    })

    let selectedCountryLabel = selectedCountry ? selectedCountry.label : "United States"
    return(
      <div className="dummy-address-block">
        <div className="row">
          <div className="col-sm-9 col-md-8 col-lg-7">
            <span className={"label-text " + (this.props.required ? "required" : "")}>Address</span>
            <DummyTextField value={this.props.value.ADDRESS_1} disabled={this.props.disabled} width="100%"/>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-9 col-md-8 col-lg-7">
            <span className="label-text">STE/APT/FL</span>
            <DummyTextField value={this.props.value.ADDRESS_2} disabled={this.props.disabled} width="100%"/>
          </div>
        </div>
        {
          !this.props.hideAttention ?
          <div className="row">
            <div className="col-sm-9 col-md-8 col-lg-7">
              <span className="label-text">Attention</span>
              <DummyTextField value={this.props.value.ADDRESS_3} disabled={this.props.disabled} width="100%"/>
            </div>
          </div>
          :
          null
        }
        {
          this.props.showCityStateZip ?
          <div className="row">
            <div className="col-sm-5 col-md-4 col-lg-3">
              <span className={"label-text " + (this.props.required ? "required" : "")}>City</span>
              <DummyTextField value={this.props.value.CITY} disabled={this.props.disabled} width="100%"/>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-2">
              <span className={"label-text " + (this.props.required ? "required" : "")}>State</span>
              <DummySelectField value={selectedState} disabled={this.props.disabled === true || this.props.disableState === true} className={this.props.disabled === true || this.props.disableState === true ? "disabled" : ""} width="100%"/>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-2">
              <span className={"label-text " + (this.props.required ? "required" : "")}>ZIP code</span>
              <DummyTextField value={this.props.value.ZIPCODE} disabled={this.props.disabled} width="100%"/>
            </div>
          </div>
          :
          null
        }
        {
          this.props.showCounty ?
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <span className={"label-text " + (this.props.required ? "required" : "")}>County</span>
              <DummyTextField value={this.props.value.COUNTY} disabled={this.props.disabled} width="100%"/>
            </div>
          </div>
          :
          null
        }
        {
          this.props.showCountry ?
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <span className={"label-text " + (this.props.required ? "required" : "")}>Country</span>
              <DummySelectField value={selectedCountryLabel} className={this.props.disabled === true || this.props.disableCountry === true ? "disabled" : ""} disabled={this.props.disabled === true || this.props.disableCountry === true} width="100%"/>
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }
}

export const DummyDataTable = () => (
	<div className='block-wrapper'>
		<table className='form-table'>
			<thead>
				<tr>
					<th>Data Table</th>
				</tr>
			</thead>
      <tbody>
        <tr>
          <td>
            &nbsp;
          </td>
        </tr>
      </tbody>
		</table>
	</div>
)

const disallowedFields = ['Paragraph', 'UploadPlaceholder']

export class DumbRepeater extends Component{
  render(){
    const { disabled, fields, template, disableAdding } = this.props;
    return(
      <div className='block-wrapper'>
        <table className={`form-table ${disabled ? 'disabled' : ''}`}>
          <thead>
            <tr>
            {
              template.filter(fieldId => !disallowedFields.includes(fields[fieldId].fieldClass)).map((fieldId, i) => (
                fields[fieldId] ?
                <th className={fields[fieldId].hideInRepeaterGrid ? 'column-hidden' : ''} key={i}>{fields[fieldId].shortLabel !== '' ? fields[fieldId].shortLabel : fields[fieldId].label}</th>
                : null
              ))
            }
            </tr>
          </thead>
        </table>
        <div className="row">
          <div className="col-sm-4 col-md-3 col-lg-3">
            {
              !disabled && !disableAdding &&
              <button
              	className='btn form-button add-row'
              	disabled={disabled}
              	type="button"
                tabIndex={-1}
              >
              	Add
              </button>
            }
          </div>
        </div>
      </div>
    )
  }
}
DumbRepeater = connect(
  (state)=>({
    fields: state.designer.wizard.fields
  })
)(DumbRepeater)

export const DummyRegisteredAgent = ({
  required,
  disabled,
  searchPlaceholder,
  sectionLabel,
  agentType1Label,
  agentType2Label,
  description,
  typeSelectionDisabled
}) => (
  <div className="registered-agent-search">
    <div className="row">
      <div className="col">
        <div className={'sub-section ' + (required ? 'required' : '')}>
          <h5>{sectionLabel || 'Search for registered agent'}</h5>
					{
						description &&
						<p className='description'>{description}</p>
					}
          {
            !typeSelectionDisabled &&
            <DumbField
            type="text"
            required={false}
            parentType="addressBlock"
            label="Select an agent type"
            description=""
          >
            <DummyRadio
              leftAlign={true}
              width="100%"
              placeholder=""
              disabled={disabled}
              options={[
                { value: 'y', label: agentType1Label || 'Commercial' },
                { value: 'n', label: agentType2Label || 'Noncommercial' }
              ]}
            />
          </DumbField>
          }
          <div className="row">
            <div className="col-9 search-col">
              <DumbField
                className="reg-search-input"
                label="Name of individual or organization"
                description=""
              >
                <DummySearchControl placeholder={searchPlaceholder} disabled={disabled} value="" />
              </DumbField>
            </div>
          </div>
          {/* <div className="row toolbar">
            <button type="button" className="btn btn-primary" onClick={this.submit}><span className="icon icon-zoom-medium"></span> Search</button>
            <button type="button" className="btn btn-white" onClick={this.submit}><span className="icon icon-close"></span> Clear Search</button>
          </div> */}
        </div>
      </div>
    </div>
  </div>
)


export const Summary = () => (
  <div className="confirm">
    <div className="row">
      <div className="col-12 confirm-col">
        <div className="confirm-step">
          <h3 className="title">Step Title</h3>
          <div className="confirm-section">
            <h3 className="section-title">Section title</h3>
            <div className="row field-divider">
               <div className="col-6">
                 <i>Field Label:</i>
               </div>
               <div className="col-6 value">
                 <b>Field Value</b>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export const DummyFullName = ({middleInitial, required, disabled, suffix, onlyRequireLastName}) => (
  <div className="row">
    <div className="col-3">
      <DumbField required={required && !onlyRequireLastName} label="First Name" description="">
        <DummyTextField value="" width="100%" disabled={disabled} />
      </DumbField>
    </div>
    <div className={middleInitial ? "col-1" : "col-2"}>
      <DumbField label="Middle/Initial" description="">
        <DummyTextField value="" width="100%" disabled={disabled} />
      </DumbField>
    </div>
    <div className="col-3">
      <DumbField required={required} label="Last Name" description="">
        <DummyTextField value="" width="100%" disabled={disabled} />
      </DumbField>
    </div>
    {
			suffix &&
			<div className="col-2">
	      <DumbField label="Suffix" description="">
	        <DummyTextField value="" width="100%" disabled={disabled} />
	      </DumbField>
	    </div>
		}
  </div>
)

export const DummyNameOrg = ({middleInitial, required, checkboxLabel, disabled, suffix}) => (
  <div>
    <div className="row">
      <div className="col-12">
        <DummyCheckbox value={false} label={checkboxLabel === '' ? "This entity is an organization" : checkboxLabel} disabled={disabled} />
      </div>
    </div>
    <DummyFullName middleInitial={middleInitial} suffix={suffix} required={required} disabled={disabled}/>
  </div>
)

export const DummyNameQualifiedOrg = ({required, individualLabel, qualifiedLabel, unqualifiedLabel, disabled, suffix}) => {
  const filteredOptions = GetFilteredOptions([individualLabel, qualifiedLabel, unqualifiedLabel])
  return(
    <div>
      <div className="row">
        <div className="col-12">
          <DummyRadio width="100%" placeholder="" disabled={disabled} options={filteredOptions} />
        </div>
      </div>
      <div className="dependent-field">
      	<GetDummyQualifiedNameField
      		individualLabel={individualLabel}
      		qualifiedLabel={qualifiedLabel}
      		unqualifiedLabel={unqualifiedLabel}
          suffix={suffix}
      		required={required}
      		disabled={disabled}
      	/>
      </div>
    </div>
  )
}

export const DummySearchControl = ({required, placeholder, disabled, width}) => {
  return(
    <div>
      <div className="row">
        <div className="dummy-search-col" style={{ width }}>
          <DummyTextField className='dummy-reg-search-input' value={placeholder || ""} disabled={disabled} />
          <button type="button" tabIndex='-1' className="btn btn-primary search-button" disabled={disabled}>
            <SearchIcon/> Search
          </button>
        </div>
      </div>
    </div>
  )
}

export const GetFilteredOptions = (labels) => {
  return labels.reduce((options, label, index) => {
    if(label !== ""){
      return [...options, {value: index, label}]
    }else{
      return options;
    }
  }, [])
}

export const GetDummyQualifiedNameField = ({individualLabel, qualifiedLabel, unqualifiedLabel, required, disabled, suffix}) => {
  if(individualLabel !== ""){
    return (
      <DummyFullName required={required} suffix={suffix} disabled={disabled}/>
    )
  }else if (qualifiedLabel !== ""){
    return(
    <div className="row">
      <div className="col-sm-7 col-md-8 col-lg-8">
        <DumbField required={required} label={qualifiedLabel} description="">
          <DummyTextField value="" width="100%" disabled={disabled}/>
        </DumbField>
      </div>
      <div className="col-sm-2 col-md-1 col-lg-1">
        <button type="button" className="btn btn-primary dumb-org-search-button"><span className="icon icon-zoom-medium"></span></button>
      </div>
    </div>
    )
  }else if(unqualifiedLabel !== ""){
    return(
      <div className="row">
        <div className="col-sm-6 col-md-7 col-lg-7">
          <DumbField required={required} label={unqualifiedLabel} description="">
            <DummyTextField value="" width="100%" disabled={disabled}/>
          </DumbField>
        </div>
      </div>
    )
  }else{
    return (
      <DummyFullName required={required} suffix={suffix} disabled={disabled}/>
    )
  }
}

export const DummyUploadAndSubmit = ({
  allowOnline,
  allowPrint,
  allowSigners,
  value: { method },
  onlineInstructions,
  mailInstructions,
  onlineTabLabel,
  printTabLabel,
  signerTabLabel
}) => (
  <div className="upload-submit">
    <div className="selectables">
      {allowOnline && (
        <div className={`selectable ${method === 'online' ? 'selected' : ''}`}>
          <div className="radio" />
          <span className="title">{onlineTabLabel || 'File Online'}</span>
        </div>
      )}
      {allowPrint && (
        <div className={`selectable ${method === 'mail' ? 'selected' : ''}`}>
          <div className="radio" />
          <span className="title">{printTabLabel || 'Print and Mail'}</span>
        </div>
      )}
      {process.env.THIRD_PARTY_SIGNING_ALLOWED && allowSigners && (
        <div className={`selectable`} style={{ marginLeft: 10 }}>
          <div className="radio" />
          <span className="title">{signerTabLabel || 'Send for Signatures'}</span>
        </div>
      )}
    </div>
    <div className="panel">
      <ReactMarkdown
        source={method === 'online' ? onlineInstructions : mailInstructions}
        className="markdown"
      />
    </div>
  </div>
)

export const DummySignatures = ({label, description, placeholder, disabled, multiple, required, showCapacity, showOnBehalfOf}) => (
  <div className='panel signatures'>
    <ReactMarkdown source={description} className='markdown attestation' />
		<div className='row'>
			{multiple && !showCapacity && <div className='col-sm-3'>Name</div>}
			{
				showCapacity && (
					<div className={`col-sm-${showOnBehalfOf ? '2' : '4'}`}>
		        <span className={`label-text  ${required ? 'required' : ''}`}>{process.env.SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"}</span>
		      </div>
				)
			}
			{
				showCapacity && showOnBehalfOf &&
				<div className='col-sm-3'>
					<span className={`label-text  ${required ? 'required' : ''}`}>On behalf of</span>
				</div>
			}
			<div className={`col-sm-${showCapacity ? showOnBehalfOf ? '4' : '5' : multiple ? '5' : '7'}`}>
        <span className={`label-text  ${required ? 'required' : ''}`}>Signature</span>
      </div>
			<div className={`col-sm-${showCapacity ? '3' : multiple ? '4' : '5'}`}>
        <span className={`label-text  ${required ? 'required' : ''}`}>Date</span>
      </div>
		</div>
    <div className="row signature-row">
      {
				multiple && !showCapacity &&
				<div className='col-sm-3 label'>
	        {label}
	      </div>
			}
			{
				showCapacity && (
					<div className={`col-sm-${showOnBehalfOf ? '2' : '4'}`}>
						<DummySelectField options={[{value: '', label: 'Self'}]} />
					</div>
				)
			}
			{
				showCapacity && showOnBehalfOf &&
				<div className='col-sm-3'>
					<DummyTextField disabled={disabled} />
				</div>
			}
      <div className={`col-sm-${showCapacity ? showOnBehalfOf ? '4' : '5' : multiple ? '5' : '7'}`}>
        <DummyTextField placeholder={placeholder} disabled={disabled} />
      </div>
			<div className={`col-sm-${showCapacity ? '3' : multiple ? '4' : '5'}`}>
        <DummyDateInput disabled={disabled}/>
      </div>
    </div>
  </div>
)

export const DummyFormationLocale = ({disabled}) =>
  <div>
    <DummyRadio
      options={[
        {value: 'STATE', label: 'United States'},
        {value: 'COUNTRY', label: 'Country'},
        {value: 'OTHER', label: 'Other'}
      ]}
      disabled={disabled}
    />
  </div>

export class DummyEntityName extends Component{
  render(){
    const {
      hideReserved,
      reservedLabel,
      nameLabel,
      nameConfirmLabel,
      nameDescription,
      hideAdditionalName,
      additionalLabel,
      additionalDescription,
      hideConsent,
      consentLabel,
      consentDescription,
      hoverId,
      required,
      disabled,
      tradeOptionLabel1,
      tradeOptionLabel2,
      consentOptionLabel1,
      consentOptionLabel2,
			nameWidth
    } = this.props;
    return(
      <div>
        {
          !hideReserved &&
          <DumbField label={reservedLabel} attrIsHovered={hoverId === 'entReserved'} required={required}>
            <DummyRadio
              options={[
                {value: 'Y', label: 'Yes'},
                {value: 'N', label: 'No'}
              ]}
              disabled={disabled}
            />
          </DumbField>
        }
        <DumbField attrIsHovered={hoverId === 'entName'} hideLabel>
          <DummyConfirmFields
          	label={nameLabel}
            description={nameDescription}
          	secondLabel={nameConfirmLabel}
          	width={nameWidth}
            required={required}
            disabled={disabled}
          />
        </DumbField>
        {
          !hideAdditionalName &&
          <DumbField
            label={additionalLabel}
            description={additionalDescription}
            attrIsHovered={hoverId === 'entAdditional'}
            required={required}
          >
            <DummyRadio
              options={[
                {value: 'N', label: tradeOptionLabel1},
                {value: 'Y', label: tradeOptionLabel2}
              ]}
              disabled={disabled}
            />
          </DumbField>
        }
        {
          !hideConsent &&
          <DumbField
            label={consentLabel}
            description={consentDescription}
            attrIsHovered={hoverId === 'entConsent'}
            required={required}
          >
            <DummyRadio
              options={[
                {value: 'N', label: consentOptionLabel1},
                {value: 'Y', label: consentOptionLabel2}
              ]}
              disabled={disabled}
            />
          </DumbField>
        }
      </div>
    )
  }
}
DummyEntityName = connect(
  state => ({
    hoverId: state.designer.hoverId
  })
)(DummyEntityName)

export const DummyUCCSearch = ({description, disabled, uccMode}) => (
	<div className='registered-agent-search'>
		<div className='sub-section'>
	    <h5>Search for UCC Documents</h5>
			{
				description &&
				<p className='description'>{description}</p>
			}
			<DumbField label={process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type'}>
				<DummyRadio
					options={[
						{value: true, label: 'Search request only'},
						{value: false, label: 'Both search and copy requests'}
					]}
					value={true}
					disabled={disabled}
				/>
			</DumbField>
      {
        process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE ?
          <DumbField label="Search Type">
            <DummyRadio
              leftAlign
              value={'DEBTOR'}
              onChange={v => this.setByKey('SEARCH_TYPE', v)}
              disabled={disabled}
              options={[
                { value: 'DEBTOR', label: 'Debtor Search' },
                { value: 'SECURED_PARTY', label: 'Secured Party Search' },
                { value: 'UCC_NUM', label: 'File Number Search' }
              ]}
            />
          </DumbField>
          :
          null
      }
			<DumbField label='Search for an individual or organziation'>
				<DummyRadio
					options={[
						{value: true, label: 'Individual'},
						{value: false, label: 'Organization'}
					]}
					value={true}
					disabled={disabled}
				/>
			</DumbField>
			<DummyFullName disabled={disabled} suffix />
			<div className='flex-row'>
				<div className='col-3'>
					<DumbField label='City'>
						<DummyTextField />
					</DumbField>
				</div>
				<div className='col-1'>
					<DumbField label='State'>
						<DummySelectField options={[{value: '', label: ''}]} />
					</DumbField>
				</div>
			</div>
			<DummyCheckbox label='Include unlapsed filings on search response.' />
			<DummyCheckbox label='Include unlapsed copy requests.' />
			{
				uccMode.toString() === '4' &&
				<React.Fragment>
					<label className='sub-label'>Select at least one of the following:</label>
					<DummyCheckbox label='Include UCC Financing statements (other than farm products)' />
					<DummyCheckbox label='Include Government Liens (IRS, indigent, employment, state tax, etc.)' />
					<DummyCheckbox label='Include Effective financing statements (EFS) pertaining to farm products' />
					<DummyCheckbox label='Include liens in crops, for seed or farm labor' />
					<DummyCheckbox label='Include liens on agricultural products, after sale/delivery to purchasers' />
				</React.Fragment>
			}
	  </div>
	</div>
)

export const DummyAltUCCSearch = ({description, disabled, uccMode}) => (
    <div className='registered-agent-search'>
        <div className='sub-section'>
            <h5>Search for UCC Documents</h5>
            {
                description &&
                <p className='description'>{description}</p>
            }
            <DumbField label={process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type'}>
                <DummyRadio
                    options={[
                        {value: true, label: 'Search request only'},
                        {value: false, label: 'Both search and copy requests'}
                    ]}
                    value={true}
                    disabled={disabled}
                />
            </DumbField>
            <div className='no-field-padding flex-row'>
                <div className='col-sm-5 col-md-4 col-lg-3'>
                    <DumbField label='Debtor City'>
                        <DummyTextField />
                    </DumbField>
                </div>
                <div className='col-sm-4 col-md-3 col-lg-2'>
                    <DumbField label='Debtor State'>
                        <DummySelectField options={[{value: '', label: ''}]} />
                    </DumbField>
                </div>
            </div>
            {
                process.env.ALT_UCC_SEARCH_SHOW_DATES ? (
                    <div>
                        <h6>Leave dates empty to search all results</h6>
                        <div className='no-field-padding flex-row'>
                            <div className='col-sm-6 col-md-5 col-lg-4'>
                                <DumbField label="Filing Date Start">
                                    <DummyDateInput disabled={disabled}/>
                                </DumbField>
                            </div>
                            <div className='col-sm-6 col-md-5 col-lg-4'>
                                <DumbField label="Filing Date End">
                                    <DummyDateInput disabled={disabled}/>
                                </DumbField>
                            </div>
                        </div>
                        <div className='no-field-padding flex-row'>
                            <div className='col-sm-6 col-md-5 col-lg-4'>
                                <DumbField label="Lapse Date Start">
                                    <DummyDateInput disabled={disabled}/>
                                </DumbField>
                            </div>
                            <div className='col-sm-6 col-md-5 col-lg-4'>
                                <DumbField label="Lapse Date End">
                                    <DummyDateInput disabled={disabled}/>
                                </DumbField>
                            </div>
                        </div>
                    </div>
                    )
                    : null
            }
            {
                process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE ?
                    <DumbField label="Search Type">
                        <DummyRadio
                            leftAlign
                            value={'DEBTOR'}
                            onChange={v => this.setByKey('SEARCH_TYPE', v)}
                            disabled={disabled}
                            options={[
                                { value: 'DEBTOR', label: 'Debtor Search' },
                                { value: 'SECURED_PARTY', label: 'Secured Party Search' },
                                { value: 'UCC_NUM', label: 'File Number Search' }
                            ]}
                        />
                    </DumbField>
                    :
                    null
            }
            <DumbField label='Search for an individual or organziation'>
                <DummyRadio
                    options={[
                        {value: true, label: 'Individual'},
                        {value: false, label: 'Organization'}
                    ]}
                    value={true}
                    disabled={disabled}
                />
            </DumbField>
            <DummyFullName disabled={disabled} suffix />
            <DummyCheckbox label='Include unlapsed filings on search response.' />
            <DummyCheckbox label='Include unlapsed copy requests.' />
            {
                uccMode.toString() === '4' &&
                <React.Fragment>
                    <label className='sub-label'>Select at least one of the following:</label>
                    <DummyCheckbox label='Include UCC Financing statements (other than farm products)' />
                    <DummyCheckbox label='Include Government Liens (IRS, indigent, employment, state tax, etc.)' />
                    <DummyCheckbox label='Include Effective financing statements (EFS) pertaining to farm products' />
                    <DummyCheckbox label='Include liens in crops, for seed or farm labor' />
                    <DummyCheckbox label='Include liens on agricultural products, after sale/delivery to purchasers' />
                </React.Fragment>
            }
        </div>
    </div>
)

export const DummyTimeInput = ({value, disabled}) => {
	const splitValue = value.split(' ')
	return (
		<div className='flex-row'>
			<DummySelectField
				disabled={disabled}
				width='70px'
				value={value.search(':') >= 0 ? value.split(':')[0] : ''}
				options={HOUR_OPTIONS}
			/>
			<DummySelectField
				disabled={disabled}
				width='70px'
				value={(value.split(':')[1] || ' ').split(' ')[0]}
				options={MINUTE_OPTIONS}
			/>
			<DummySelectField
				disabled={disabled}
				width='70px'
				value={splitValue[1]}
				options={[
					{value: 'am', label: 'am'},
					{value: 'pm', label: 'pm'}
				]}
			/>
		</div>
	)
}

export const DummyMultiComplete = ({width, placeholder}) => (
	<DummySelectField width={width} placeholder={placeholder} />
)

export const DummyEFSPicker = ({disabled}) => (
	<DummyRadio
		options={[
			{ value: '', label: 'All years' },
			{ value: '', label: process.env.EFS_CROP_PICKER_NONE_LABEL || 'None' },
			{ value: '', label: 'Specified Year Through Duration' },
			{ value: '', label: 'Specified Years' }
		]}
		disabled={disabled}
	/>
)

export const DummyLocalSelect = ({placeholder, width}) => (
	<DummySelectField placeholder={placeholder} width={width} />
)



// WEBPACK FOOTER //
// ./src/components/Designer2/DummyInputs.js